export const ENTRA_SCOPES = ['openid', 'profile'] as const;
